var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorimg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 77,
    viewBox: "0 0 351 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339.975 28.0765C335.801 28.0765 332.218 30.7613 330.739 34.5337C272.133 38.442 123.465 38.0342 72.6824 33.956C70.5131 15.2641 55.196 0.752441 36.5591 0.752441C16.4102 0.752441 0.0742188 17.6431 0.0742188 38.476C0.0742188 59.3089 16.4102 76.1995 36.5591 76.1995C55.2288 76.1995 70.5459 61.6878 72.6824 42.962C130.631 38.8158 264.08 38.476 330.772 42.4183C332.284 46.1567 335.834 48.8075 340.008 48.8075C345.53 48.8075 350.033 44.1515 350.033 38.442C350.033 32.7325 345.563 28.0765 340.008 28.0765H339.975Z",
    fill: "#F3393A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorimg4);
export default __webpack_public_path__ + "static/media/Vectorimg4.be5be577935d93da21b5a86927d73138.svg";
export { ForwardRef as ReactComponent };